import axios from "./axios.js";

// Fetch every reaction of every enzyme belonging to one species or one kingdom
// label, for the species / kingdom pages (Client/TaxonomyPage.js).
//
// Uses the `speciesExact` / `kingdomsExact` filters of /basicsearch rather than
// the older `species` / `kingdoms` ones: those interpolate the value into the
// SQL string, and here the value comes straight out of the URL. The Exact pair
// is bound with placeholders instead (see backend basicSearchController).
// `allEnzymeReactions` is not needed — filtering on kingdom/species already
// selects whole enzymes, so every reaction of a matching enzyme comes back.
async function fetchTaxonomyReactions(mode, value) {
  const body = mode === "species" ? { speciesExact: [value] } : { kingdomsExact: [value] };
  const res = await axios.post("/basicsearch", body);
  return Array.isArray(res.data) ? res.data : [];
}

export default fetchTaxonomyReactions;
